/**
 * ArkShortcuts - 全局键盘快捷键 JSInterop 桥
 *
 * 监听 document keydown，过滤 input/textarea/select/contenteditable
 * （让原生 undo / 复制粘贴对输入框生效），把指定快捷键派发给 .NET。
 *
 * 用法：
 *   ArkShortcuts.register(scopeId, dotnetRef)
 *     dotnetRef 必须暴露 [JSInvokable("HandleShortcut")] HandleShortcut(key, ctrl, shift, alt)
 *     返回 true 表示已处理（preventDefault），false 表示放行
 *   ArkShortcuts.unregister(scopeId)
 *
 * v1.0 设计要点：
 * - 使用 capture 阶段（不被子组件 stopPropagation 吞掉，例如 ArkDialog 的 Esc）
 * - 仅派发"看起来像快捷键"的事件：含 Ctrl/Cmd 修饰键 / Delete / Escape
 *   普通字母键（无修饰）不派发，避免与输入冲突
 */

const handlers = new Map();

function isEditableTarget(target) {
    if (!target) return false;
    const tag = target.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
    if (target.isContentEditable) return true;
    return false;
}

function makeHandler(dotnetRef) {
    return (e) => {
        if (isEditableTarget(e.target)) return;

        const ctrl = e.ctrlKey || e.metaKey;
        const shift = e.shiftKey;
        const alt = e.altKey;
        const key = e.key;

        // 只派发"看起来像快捷键"的事件，避免噪音
        const isShortcut = ctrl || key === 'Delete' || key === 'Escape';
        if (!isShortcut) return;

        dotnetRef.invokeMethodAsync('HandleShortcut', key, ctrl, shift, alt)
            .then(handled => {
                if (handled) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            })
            .catch(err => console.warn('[ArkShortcuts] dispatch failed:', err));
    };
}

const ArkShortcuts = {
    register(scopeId, dotnetRef) {
        if (handlers.has(scopeId)) {
            this.unregister(scopeId);
        }
        const handler = makeHandler(dotnetRef);
        document.addEventListener('keydown', handler, { capture: true });
        handlers.set(scopeId, { dotnetRef, handler });
    },

    unregister(scopeId) {
        const entry = handlers.get(scopeId);
        if (!entry) return;
        document.removeEventListener('keydown', entry.handler, { capture: true });
        handlers.delete(scopeId);
    }
};

window.ArkShortcuts = ArkShortcuts;

export default ArkShortcuts;
